import {
    ODataHeader,
    ODataString,
    ODataInteger,
    ODataDate
} from "pbas-vue-components";
import { translate } from '../trans'
import store from '@/store'

const PortalContactsHeaders = [
    new ODataHeader({
        title: "globals.language",
        type: new ODataString("Language"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.priority",
        type: new ODataInteger("Order"),
        sortable: true,
        visible: true,
        allowVisibilityChange: true,
        searchable: true
    }),
    new ODataHeader({
        title: "Id",
        type: new ODataString("Id"),
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "PlanId",
        type: new ODataString("PlanId"),
        visible: false,
        searchable: false,
        isIdentifier: true,
        allowVisibilityChange: false
    }),
    new ODataHeader({
        title: "globals.name",
        type: new ODataString("Name"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "headers.contacts.email",
        type: new ODataString("Email"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.phone",
        type: new ODataString("Phone"),
        sortable: true,
        visible: true,
        searchable: true
    }),
    new ODataHeader({
        title: "globals.address",
        type: new ODataString("Address"),
        sortable: true,
        visible: true,
        searchable: true
    })
];
export default PortalContactsHeaders;